var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    viewBox: "0 0 25 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3143 0.808342C6.74284 0.808342 1.98484 4.27377 0.0571289 9.16549C1.98484 14.0572 6.74284 17.5226 12.3143 17.5226C17.8857 17.5226 22.6437 14.0572 24.5714 9.16549C22.6437 4.27377 17.8857 0.808342 12.3143 0.808342ZM12.3143 14.7369C9.23886 14.7369 6.74286 12.2409 6.74286 9.16549C6.74286 6.09006 9.23886 3.59406 12.3143 3.59406C15.3897 3.59406 17.8857 6.09006 17.8857 9.16549C17.8857 12.2409 15.3897 14.7369 12.3143 14.7369ZM12.3144 5.82263C10.4647 5.82263 8.97152 7.31577 8.97152 9.16548C8.97152 11.0152 10.4647 12.5083 12.3144 12.5083C14.1641 12.5083 15.6572 11.0152 15.6572 9.16548C15.6572 7.31577 14.1641 5.82263 12.3144 5.82263Z",
    fill: "#8D9197"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_27:418",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3143 0.808342C6.74284 0.808342 1.98484 4.27377 0.0571289 9.16549C1.98484 14.0572 6.74284 17.5226 12.3143 17.5226C17.8857 17.5226 22.6437 14.0572 24.5714 9.16549C22.6437 4.27377 17.8857 0.808342 12.3143 0.808342ZM12.3143 14.7369C9.23886 14.7369 6.74286 12.2409 6.74286 9.16549C6.74286 6.09006 9.23886 3.59406 12.3143 3.59406C15.3897 3.59406 17.8857 6.09006 17.8857 9.16549C17.8857 12.2409 15.3897 14.7369 12.3143 14.7369ZM12.3144 5.82263C10.4647 5.82263 8.97152 7.31577 8.97152 9.16548C8.97152 11.0152 10.4647 12.5083 12.3144 12.5083C14.1641 12.5083 15.6572 11.0152 15.6572 9.16548C15.6572 7.31577 14.1641 5.82263 12.3144 5.82263Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_27:418)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.1b8fa8dd.svg";
export { ForwardRef as ReactComponent };